import { render } from "./alertpage.vue?vue&type=template&id=4dfe0430&scoped=true"
import script from "./alertpage.vue?vue&type=script&lang=js"
export * from "./alertpage.vue?vue&type=script&lang=js"

import "./alertpage.vue?vue&type=style&index=0&id=4dfe0430&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfe0430"]])

export default __exports__